module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<td style="width: 117px;"><a href="#" name="open_profile">'+
((__t=( toUpper(patient_name) ))==null?'':__t)+
'</a></td>\n\n';
 if (!isSimple) { 
__p+='\n<td style="width: 115px;"><a tabindex="0" name="refpo" role="button" data-toggle="popover"\n                             title="<span class=\'close clickable active-sort-header left-close-btn\'>&times;</span>&nbsp;&nbsp;&nbsp;<span class=\'popover-title-custom\'>Additional Info</span>&nbsp;<span class=\'close clickable active-sort-header right-close-btn\'>&times;</span>"\n                             data-html="true">'+
((__t=( formatDate(referral_date) ))==null?'':__t)+
'</a></td>\n';
 } 
__p+='\n\n<td style="width: 91px;"><a tabindex="0" name="socpo" role="button" data-toggle="popover"\n                            title="<span class=\'close clickable active-sort-header left-close-btn\'>&times;</span>&nbsp;&nbsp;&nbsp;<span class=\'popover-title-custom\'>Additional Info</span>&nbsp;<span class=\'close clickable active-sort-header right-close-btn\'>&times;</span>"\n                            data-html="true">'+
((__t=( formatDate(soc) ))==null?'':__t)+
'</a></td>\n\n';
 if (!isSimple) { 
__p+='\n<td style="width: 102px;">'+
((__t=( toUpper(admit) ))==null?'':__t)+
'</td>\n';
 } 
__p+='\n\n';
 if (variant!='referral') { 
__p+='\n<td style="width: 116px;">'+
((__t=( formatDate(transfer_date) ))==null?'':__t)+
'</td>\n<td style="width: 123px;">'+
((__t=( formatDate(status) ))==null?'':__t)+
'<br>'+
((__t=( toUpper(dc_type) ))==null?'':__t)+
'</td>\n';
 } 
__p+='\n\n\n';
 if (!isSimple) { 
__p+='\n<td style="width: 120px;">'+
((__t=( toUpper(md) ))==null?'':__t)+
'</td>\n<td style="width: 230px;">'+
((__t=( toUpper(location) ))==null?'':__t)+
'</td>\n<td style="width: 180px; text-transform:capitalize;">\n    ';
 _.each([jencare_coordinators.split(':')[0]], function(jc){
__p+='\n    '+
((__t=( toUpper(jc) ))==null?'':__t)+
'<br>';
 }) 
__p+='\n</td>\n<td style="width: 140px;">'+
((__t=( toUpper(insurance) ))==null?'':__t)+
'</td>\n<td style="width: 130px;">'+
((__t=( toUpper(intake) ))==null?'':__t)+
'</td>\n<td style="width: 130px;">'+
((__t=( toUpper(cm_sn) ))==null?'':__t)+
'</td>\n<td style="width: 60px;">\n    ';
 if (soc!=null) { 
__p+='\n    <a tabindex="0" name="jfspov" data-html="true" class="btn btn-primary btn-sm" role="button" data-toggle="popover"\n       title="<span class=\'popover-title-custom\'>Frequency of Visits</span>&nbsp;<span class=\'close clickable active-sort-header right-close-btn\'>&times;</span>">View</a>\n    ';
 } 
__p+='\n</td>\n<td style="width: 60px;">\n    ';
 if (soc!=null) { 
__p+='\n    <a tabindex="0" name="jfsvis" data-html="true" class="btn btn-primary btn-sm" role="button" data-toggle="popover"\n       title="<span class=\'popover-title-custom\'>Visits</span>&nbsp;<span class=\'close clickable active-sort-header right-close-btn\'>&times;</span>">View</a>\n    ';
 } 
__p+='\n</td>\n';
 } 
__p+='\n<td style="width: 80px;" class="center">\n    <button class="btn btn-primary btn-sm rns-docs">Open</button>\n</td>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/organizations/organization-patients-row.html
// module id = 298
// module chunks = 0